import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useCatalogStore } from '../../store/catalogStore';
import ProductGrid from '../ProductGrid/ProductGrid';
export default function SearchPage() {
  const [params] = useSearchParams();
  const query = (params.get('q') ?? '').trim();
  const fetchSearch = useCatalogStore((state) => state.fetchSearch);
  useEffect(() => {
    if (!query) return;
    const state = useCatalogStore.getState();
    if (state.viewMode !== 'search' || state.query !== query || state.error !== null) void fetchSearch(query);
  }, [query, fetchSearch]);
  if (!query) return <Navigate to="/" replace />;
  return (
    <section className="page-container">
      <h1>Search results for “{query}”</h1>
      <ProductGrid />
    </section>
  );
}
